import { TransactionsStore } from '.';
import { RootState } from '../..';

export const selectTransactions = (state: RootState): TransactionsStore => state.transactions;
